import React from "react";
import AuthProvider from "./src/components/Auth/AuthContext";
import './src/styles/reset.css';
import './src/styles/global.css';
import './src/styles/mobile.css';
import './src/styles/menu.css';
import './src/styles/slider.css';
import './src/styles/forms.css';
import './src/styles/form.css';
import './src/styles/hotspot.css';

export const wrapRootElement = ({ element }) => (
  <AuthProvider>{element}</AuthProvider>
);